module.exports = __webpack_public_path__ + "static/media/nft.cf595fac.jpeg";